<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'TrainLayout',
};
</script>

<style scoped></style>
